(function(){
    // Delete hash from address bar
    if (location.hash) {
        let hash = location.hash;
        history.replaceState({}, '', location.href.replace(hash, ''));

        let section = document.querySelector(hash);

        if (section) {
            section.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }


    const anchorLinks = document.querySelectorAll('a[href*="#"]');
    const add_offset = 50;

    if (anchorLinks) {
        anchorLinks.forEach(anchor => {

            let link = anchor.href.split('#')[0];
            let hash = anchor.href.split('#')[1];

            anchor.addEventListener('click', function (e) {

                if (link == window.location.href) {
                    e.preventDefault();

                    if (hash) {
                        let section = document.getElementById(hash);

                        if(section) {
                            let offset = section.offsetTop - add_offset;

                            window.scrollTo({ top: offset, behavior: "smooth" });
                        }
                    }
                }
            });
        });
    }
})();
